import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import DDIAInitiateProposalPageStore, {
  DDIAInitiateProposalPageStoreContext,
  useDDIAInitiateProposalPageStore,
} from 'store/pages/initiate-quote/ddia/pageStore';
import DDIAInitiateProposalForm from 'components/initiate-quote/DDIA';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useDDIAInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <DDIAInitiateProposalForm key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={proposalExperienceStepController.experiences}
          experienceDisabledReasons={proposalExperienceStepController.experienceDisabledReasons}
          experienceAccessLimitations={proposalExperienceStepController.experienceAccessLimitations}
          renewalActionsDelegate={proposalExperienceStepController.renewalActionsDelegate}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const DDIAInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new DDIAInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <DDIAInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDIAInitiateProposalPageStoreContext.Provider>
  );
};

export default DDIAInitiateProposalPage;
